export default __webpack_public_path__ + "static/media/Emotional08.9a115bfa.png";